import React, { useId, useState } from "react";

// Chip-style tag editor: Enter or comma adds a tag, Backspace on an empty input removes the last one.
const TagInput = ({ value = [], onChange, suggestions = [], max = 20, placeholder = "Add a tag", disabled = false, label = "Tags" }) => {
  const [draft, setDraft] = useState("");
  const listId = useId();
  const add = (raw) => {
    const tag = raw.trim().replace(/,+$/, "").slice(0, 40);
    if (!tag || value.some((item) => item.toLowerCase() === tag.toLowerCase()) || value.length >= max) { setDraft(""); return; }
    onChange([...value, tag]);
    setDraft("");
  };
  const available = suggestions.filter((tag) => !value.some((item) => item.toLowerCase() === tag.toLowerCase()));
  return <div className={`leads-tag-input${disabled ? " is-disabled" : ""}`}>
    {value.map((tag) => <span className="leads-tag" key={tag}>{tag}{!disabled && <button type="button" onClick={() => onChange(value.filter((item) => item !== tag))} aria-label={`Remove tag ${tag}`}><i className="ti ti-x" /></button>}</span>)}
    {!disabled && value.length < max && <input
      aria-label={label}
      list={available.length ? listId : undefined}
      value={draft}
      placeholder={value.length ? "" : placeholder}
      maxLength={41}
      onChange={(event) => { if (event.target.value.endsWith(",")) add(event.target.value); else setDraft(event.target.value); }}
      onKeyDown={(event) => {
        if (event.key === "Enter") { event.preventDefault(); add(draft); }
        else if (event.key === "Backspace" && !draft && value.length) onChange(value.slice(0, -1));
      }}
      onBlur={() => draft.trim() && add(draft)}
    />}
    {available.length > 0 && <datalist id={listId}>{available.slice(0, 30).map((tag) => <option key={tag} value={tag} />)}</datalist>}
  </div>;
};

export default TagInput;
